import Config from 'lib/Config';
import React from 'react';
import Helmet from 'react-helmet';
import Button from '../../shared/app/Button';
import CurrencyInput from '../../shared/app/CurrencyInput';
import './style.scss';

const TAB = '&nbsp;&nbsp;&nbsp;&nbsp;';
const OBRACE = '&#123;';
const CBRACE = '&#125;';

const StyleGuide = () => (
    <div id="style-guide" className="page-layout">
        <Helmet><title>{Config.SITE_TITLE_PREFIX} - Style Guide</title></Helmet>

        <h1>AdCloud Style Guide</h1>

        <p>
            <b>Goals:</b> Bring together common classes, display all options, show useable mixins.
            Possibly explain things, ie. clamp() for some mixins, etc.
        </p>

        <section className="layout">
            <h1>Layout</h1>
        </section>

        <section className="headers">
            <h1>Headers</h1>
        </section>

        <section className="inputs">
            <h1>Inputs</h1>

            <div className="entry">
                <div className="class">input simple</div>
                <div className="definition">See styles/app/controls/input.scss.</div>
                <div className="example dark">
                    <input type="text" className="input simple" placeholder="EMAIL"/>
                </div>
            </div>

        </section>

        <section className="buttons">
            <h1>Buttons</h1>

            <div className="entry">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;Button round color="blue">Example&lt;/Button><br/><br/>`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/button.scss.`
                    }}>
                </div>
                <div className="example">
                    <Button round color="blue">Example</Button>
                </div>
            </div>

            <div className="entry">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;Button round filled color="blue">Example&lt;/Button><br/><br/>`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/button.scss.`
                    }}>
                </div>
                <div className="example">
                    <Button round filled color="blue">Example</Button>
                </div>
            </div>

            <div className="entry">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;Button round color="green">Example&lt;/Button><br/><br/>`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/button.scss.`
                    }}>
                </div>
                <div className="example">
                    <Button round color="green">Example</Button>
                </div>
            </div>

            <div className="entry">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;Button round filled color="green">Example&lt;/Button><br/><br/>`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/button.scss.`
                    }}>
                </div>
                <div className="example">
                    <Button round filled color="green">Example</Button>
                </div>
            </div>

            <div className="entry">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;Button round filled color="green" textColor="white">Example&lt;/Button>`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/button.scss.`
                    }}>
                </div>
                <div className="example">
                    <Button round filled color="green" textColor="white">Example</Button>
                </div>
            </div>

            <div className="entry currency-input">
                <div className="usage" dangerouslySetInnerHTML={{__html:
                    `&lt;CurrencyInput<br/>
                        ${TAB}placeholder="Currency..."<br/>
                        ${TAB}canEdit<br/>
                        ${TAB}buttonProps={{ round: true, color: 'green', textColor: 'white' }}<br/>
                        ${TAB}onChange={(val) => {}}<br/>
                        ${TAB}onSave={(val) => {}}<br/>
                        ${TAB}value={...}<br/>
                        ${TAB}name="..."<br/>
                    />`
                    }}>
                </div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `See styles/app/controls/currency-input.scss.`
                    }}>
                </div>
                <div className="example">
                    <CurrencyInput
                        canEdit
                        buttonProps={{ round: true, color: 'green', textColor: 'white' }}
                    />
                </div>
            </div>

        </section>

        <section className="headers">
            <h1>Text</h1>

            <div className="entry">
                <div className="class">font-label</div>
                <div className="definition"  dangerouslySetInnerHTML={{__html:
                    `@mixin font-label {<br/>
                        ${TAB}font-family: 'Grotesk Bold';<br/>
                        ${TAB}font-size: .875rem;<br/>
                        ${TAB}line-height: 1rem;<br/>
                        ${TAB}font-weight: 200;<br/>
                        ${TAB}letter-spacing: 2px;<br/>
                        ${TAB}text-transform: uppercase;<br/>
                    }`
                }}>
                </div>
                <div className="example">
                    <div className="font-label">Example</div>
                </div>
            </div>

            <div className="entry">
                <div className="class">font-plain-large</div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `@mixin font-plain-large {<br/>
                        ${TAB}font-family: 'Grotesk';<br/>
                        ${TAB}font-size: 1.6875rem;<br/>
                        ${TAB}line-height: 1.6875rem;<br/>
                        ${TAB}font-weight: 600;<br/>
                    }`
                }}>
                </div>
                <div className="example">
                    <div className="font-plain-large">Example</div>
                </div>
            </div>

            <div className="entry">
                <div className="class">font-label-light</div>
                <div className="definition" dangerouslySetInnerHTML={{__html:
                    `@mixin font-label-light {<br/>
                        ${TAB}font-family: 'Grotesk';<br/>
                        ${TAB}font-size: .9375rem;<br/>
                        ${TAB}line-height: 1em;<br/>
                        ${TAB}font-weight: 200;<br/>
                        ${TAB}letter-spacing: 1px;<br/>
                        ${TAB}text-transform: uppercase;<br/>
                    }`
                }}>
                </div>
                <div className="example">
                    <div className="font-label-light">Example</div>
                </div>
            </div>

        </section>

        <section className="graphs">
            <h1>Graphs</h1>
        </section>

        <section className="colors">
            <h1>Colors</h1>

            <div className="entry">
                <div className="class">blue</div>
                <div className="definition">
                    --color-blue: #3976EE;
                </div>
                <div className="example">
                    <div className="blue bg">Example</div>
                </div>
            </div>

            <div className="entry">
                <div className="class">blue-dark</div>
                <div className="definition">
                    --color-blue-dark: #142643;
                </div>
                <div className="example">
                    <div className="blue-dark bg">Example</div>
                </div>
            </div>

            <div className="entry">
                <div className="class">green</div>
                <div className="definition">
                    --color-green: #66FFCC;
                </div>
                <div className="example">
                    <div className="green bg">Example</div>
                </div>
            </div>

        </section>

        <section className="suggestions">
            <h1>Suggestions</h1>

            -use sass variables for localized variables (that you might want to repeat often in a single file). Use global css vars for shared variables.

            React rendering:
            -try to reduce renderings with less calls to 'set*()' by combining the data into a single object.
        </section>

    </div>
)

export default StyleGuide
